import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';

const CONSENT_KEY = 'apex_cookie_consent';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Show banner if user hasn't accepted yet
        const consent = localStorage.getItem(CONSENT_KEY);
        if (!consent) {
            // Small delay so it doesn't flash on load
            const timer = setTimeout(() => setVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(CONSENT_KEY, new Date().toISOString());
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[9999] animate-fade-in">
            <div className="max-w-2xl mx-auto p-4">
                <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                    <Shield size={24} className="text-brand-500 flex-shrink-0 mt-0.5 sm:mt-0" />
                    <div className="flex-1 min-w-0">
                        <p className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
                            Ta strona używa <strong>plików cookie niezbędnych do działania</strong> (sesja logowania, uwierzytelnianie).
                            Nie używamy cookies marketingowych ani śledzących.
                        </p>
                        <p className="text-xs text-slate-500 mt-1">
                            Zgodnie z art. 173 Prawa telekomunikacyjnego i RODO (UE 2016/679).
                        </p>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
                        <button
                            onClick={accept}
                            className="flex-1 sm:flex-initial px-5 py-2 rounded-lg bg-brand-600 hover:bg-brand-700 text-white text-sm font-semibold transition-colors"
                        >
                            Akceptuję
                        </button>
                        <button
                            onClick={accept}
                            className="p-2 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
                            title="Zamknij"
                        >
                            <X size={16} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
